/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AgeGroup } from "./AgeGroup";
import type { ApplicationArea } from "./ApplicationArea";
import type { ProductFormat } from "./ProductFormat";
import type { UnitPriceUnit } from "./UnitPriceUnit";
export type UpdateOrganizationProductRequest = {
  name?: string;
  description?: string;
  product_function?: string;
  application_areas?: Array<ApplicationArea>;
  product_format?: ProductFormat;
  leave_on?: boolean;
  is_otc?: boolean;
  age_groups?: Array<AgeGroup>;
  target_price?: number;
  target_price_unit?: UnitPriceUnit;
  unset?: UpdateOrganizationProductRequest.unset;
};
export namespace UpdateOrganizationProductRequest {
  export enum unset {
    TARGET_PRICE_UNIT = "target_price_unit",
  }
}
